export default {
	QUIZ_QUESTIONS: 'QUIZ/QUESTIONS',
	QUIZ_ANSWERS: 'QUIZ/ANSWERS',
	STOREFRONT_LESSONS: 'STOREFRONT/LESSONS',
	PRIVATE_LIBRARY_LESSONS: 'PRIVATE_LIBRARY/LESSONS',
	PRIVATE_LIBRARY_FOLDERS: 'PRIVATE_LIBRARY/FOLDERS',
	MY_LIBRARY_LESSONS: 'MY_LIBRARY/LESSONS',
	MY_LIBRARY_FOLDERS: 'MY_LIBRARY/FOLDERS',
}
